import { useForm } from "react-hook-form";
import { useNotificadoresStore } from "../../../../store/notificadoresStore";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import FilterMonths from "../FilterMonths";
import { getYear, getMonth, format, parse } from 'date-fns';
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import ModalFiltroFechas from "../../../../views/modals/ModalFiltroFechas";
import Table2 from "../../../../components/Table2";
import { tableData } from "./tableData";
import { useActaDetalleStore } from "../../../../store/actaDetalleStore";
import { useActas } from "../../../../hooks/useActas";
import { MuniSpinner2 } from "../../../../components";
import ExcelButton from "../../../../components/ExcelButton";
import ExcelFront from "../../../../components/ExcelFront";
import { Tooltip } from "@mui/material";

const NotificadoresBar2 = ({ setFiltersField, filtros, setFiltros }) => {

    const { notificadorSelect, setNotificadorSelect, setFilterReporteNotificadores, filterReporteNotificadores, reporteNotificador, fechasReporte, setFechasReporte, setFilterEstado, setSubmitFilter, filterEstado } = useNotificadoresStore();
    const { handlerModal, modals, loads } = useGeneralAppStore();
    // const { actas, actasFilter, setActasFilter, cleanActas, codigosZonales } = useActasStore();
    const [order, setOrder] = useState("des");
    const [orderField, setOrderField] = useState("numero_acta");
    const { cleanStore, coleccionActasDetalle, setAllActaDetalle } = useActaDetalleStore();
    const { getActas, getActaDetalle } = useActas()

    const { register, setValue, watch } = useForm();
    const [selectMeses, setSelectMeses] = useState({ value: (getMonth(new Date()) + 1).toString().padStart(2, '0') });
    const [añoSeleccionado, setAñoSeleccionado] = useState(getYear(new Date()));

    const [actasFilter, setActasFilter] = useState();

    const notificadores = [
        { id: 1, usuarioID: 165406, nombre: "SEND SRL" },
        { id: 2, usuarioID: 86065, nombre: "CASTILLO, MARIA YANET" },
    ]
    const estados = [
        // reparto,notificadas,no-notificadas
        { valor: 'reparto', estado: "EN REPARTO" },
        { valor: 'no-notificadas', estado: "SIN ENTREGAR" },
        { valor: 'notificadas', estado: "NOTIFICADO" },
        { valor: 'todas', estado: "REPORTE" },
    ]

    useEffect(() => {

        return () => {
            setNotificadorSelect(null);
            setSubmitFilter(false)
        }
    }, [])

    const headers = [
        // { label: "ID", key: "id" },
        { label: "#Acta", key: "numero_acta" },
        { label: "Localidad", key: "localidad" },
        { label: "Fecha reporte", key: "fecha_reporte" },
        { label: "Estado", key: "estado_id" },
        // { label: "Patente", key: "plate" },
        // { label: "Documento", key: "documento_titular" },
    ];

    // useEffect(() => {
    //     if (reporteNotificador) {
    //         setActasFilter(reporteNotificador)
    //     }
    // }, [])

    useEffect(() => {
        if (notificadorSelect) {
            setFilterReporteNotificadores({
                user_id: notificadorSelect?.usuarioID,
                mes: selectMeses?.value,
                anio: añoSeleccionado.toString(),
                estado_id: [8, 9, 4, 11, 12, 13, 15]
            })
        } else {
            setFilterReporteNotificadores(null)
        }
    }, [notificadorSelect, añoSeleccionado, selectMeses])

    // const handlerFiltro = () => {
    //     setSubmitFilter(true)

    // }

    return (
        <section>
            <p className="fw-bold m-0">Notificadores</p>
            <Form.Select
                className="mb-3"
                style={{ width: "fit-content" }} size="sm"
                disabled={loads?.includes('reporte_notificadores')}
                onChange={(a) => {
                    if (a.target.value == "") {
                        setNotificadorSelect(null);
                    } else {
                        setNotificadorSelect(notificadores.find(not => not.usuarioID == a.target.value))
                    }

                }}
            >
                <option value={""}>Seleccione notificador</option>
                {notificadores.map((a) => (
                    <option key={a.usuarioID} value={a.usuarioID}>
                        {a.nombre}
                    </option>
                ))}
            </Form.Select>

            <div style={{ width: '100%', minHeight: "500px" }} className="border rounded border-3">
                {
                    !notificadorSelect
                        ?

                        <div className="w-100 d-flex justify-content-center align-items-center  " style={{ minHeight: "500px" }}>
                            <p className="m-0 fw-semibold ">
                                Seleccione un notificador
                            </p>
                        </div>
                        :
                        <div>
                            {/* <FilterMonths setFiltersField={setFiltersField} selectMeses={selectMeses} setSelectMeses={setSelectMeses} añoSeleccionado={añoSeleccionado} setAñoSeleccionado={setAñoSeleccionado} /> */}

                            <section className="row p-4">
                                <div className="col-12 col-md-4">
                                    <div className="d-flex flex-column align-items-center m-4">
                                        <select className="form-select" defaultValue="todas" aria-label="Default select example" style={{ width: "fit-content" }}
                                            onChange={(a) => {
                                                if (a.target.value == "") {
                                                    setFilterEstado('todas');
                                                } else {
                                                    setFilterEstado(a.target.value)
                                                }

                                            }}
                                        >

                                            {estados.map((a) => (
                                                <option key={a.estado} value={a.valor}>
                                                    {a.estado}
                                                </option>
                                            ))}
                                        </select>
                                        <p className="m-0 text-primary fw-bold">Fechas</p>
                                        <button
                                            disabled={loads.includes('reporte_notificadores')}
                                            onClick={() => handlerModal({ modal: true, modalName: "rango_fecha" })}
                                            style={{ cursor: "pointer", paddingTop: "2px", paddingBottom: "2px", width: "fit-content" }}
                                            className="border border-1 border-secondary-subtle rounded mx-auto"
                                        >

                                            {/* {!filtros?.fecha_desde && !filtros?.fecha_hasta && "Filtrar fechas"}
                                {filtros?.fecha_desde && !filtros?.fecha_hasta && `Desde ${format(parse(filtros?.fecha_desde, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}`}
                                {!filtros?.fecha_desde && filtros?.fecha_hasta && `Hasta ${format(parse(filtros?.fecha_hasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}`}
                                {filtros?.fecha_desde && filtros?.fecha_hasta && `${format(parse(filtros?.fecha_desde, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')} - ${format(parse(filtros?.fecha_hasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}`} */}
                                            {format(fechasReporte?.fecha_desde, 'dd/MM/yy')} -
                                            {format(fechasReporte?.fecha_hasta, 'dd/MM/yy')}
                                        </button>
                                        <button
                                            className="flex items-center gap-2 bg-primary hover:bg-blue-700 text-white px-4 py-2 rounded-md mt-4"
                                            style={{ cursor: "pointer", paddingTop: "2px", paddingBottom: "2px", width: "fit-content" }}
                                            onClick={() => setSubmitFilter(true)}
                                        >
                                            Filtrar Actas
                                        </button>
                                    </div>
                                    {
                                        loads?.includes('reporte_notificadores')
                                            ?
                                            <MuniSpinner2 />
                                            :
                                            <div className="border border-1 border-secondary-subtle p-2 rounded d-flex flex-column gap-2">
                                                <p className="m-0"><span className="fw-bold me-1">Total actas:</span>{reporteNotificador?.length}</p>
                                                {(filterEstado == 'todas') && <p className="m-0"><span className="fw-bold me-1">Actas notificadas:</span>{reporteNotificador?.filter(acta => acta?.fecha_notificacion)?.length}</p>}
                                                {(filterEstado == 'todas') && <p className="m-0"><span className="fw-bold me-1">Actas visitadas:</span>{reporteNotificador?.filter(acta => acta?.fecha_no_notificado && !acta?.fecha_notificacion)?.length}</p>}
                                            </div>
                                    }
                                    {
                                        (!loads?.includes('reporte_notificadores') && reporteNotificador) &&
                                        <div className="d-flex w-100 justify-content-center mt-4">
                                            <Tooltip title='Descargar reporte' arrow>
                                                <div>
                                                    <ExcelFront headers={headers} data={reporteNotificador} filename={`reporte-${notificadorSelect?.nombre}.csv`} />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                                <div className="col-12 col-md-8">
                                    <Table2
                                        // onPaginationModelChange={null}
                                        // paginationModel={null}
                                        pageSizeOptions={[10, 25, 50]}
                                        height={"500px"}
                                        loading={loads.some(load =>
                                            ["reporte_notificadores", "asignar_notificador", "acta_detalle", "desasignar_notificador", "marcar_impresa", "actas_a_imprimir", "actas", "notificadores"].includes(load)
                                        )}
                                        data={tableData(
                                            // actasFilter,
                                            reporteNotificador,
                                            setFiltersField,
                                            setOrder,
                                            setOrderField,
                                            coleccionActasDetalle,
                                            setAllActaDetalle,
                                            handlerModal,
                                            getActaDetalle,
                                            filterEstado
                                        )}
                                        getRowClassName={({ row }) => {
                                            if (row?.estado_id == 4 || row?.estado_id == 11 || row?.estado_id == 13) {
                                                return 'notificado';
                                            } else if (row.estado_id == 9) {
                                                return 'motivo';
                                            } else {
                                                return "reporte";
                                            }
                                        }}

                                        sx={{
                                            ".MuiDataGrid-row.notificado": {
                                                backgroundColor: '#BCD9CF',
                                                color: "#111"
                                            },
                                            ".MuiDataGrid-row.motivo": {
                                                backgroundColor: '#FFEDB5',
                                                color: "#111"
                                            },
                                            ".MuiDataGrid-row.reporte": {
                                                backgroundColor: 'white',
                                                color: "black"
                                            },
                                            ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.reporte": {
                                                backgroundColor: '#D6D6D6',
                                                color: "black"
                                            },
                                            ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.notificado": {
                                                backgroundColor: '#A2BFB5',
                                                color: "#111"
                                            },
                                            ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.motivo": {
                                                backgroundColor: '#E8D69E',
                                                color: "#111"
                                            },
                                        }}
                                    />
                                </div>

                            </section>

                        </div>
                }
            </div>
            {modals.includes('rango_fecha') && <ModalFiltroFechas filtros={filtros} setFiltros={setFiltros} showButtonSubmit={false} />}
            {/* {modals.includes('rango_fecha') && <ModalFiltroFechas filtros={filtros} setFiltros={setFiltros} />} */}
        </section>
    )
}

export default NotificadoresBar2;